import { compose } from 'redux';

import {
    WithStatelessDatasFetchingByParameters,
    WithNotifyRessourceLoaded,
    WithNotifyRessourceLoadedInputProps,
} from 'modules/shared/hocs';
import { WithFetchDatasByParamsFromCMS } from 'modules/shared-cms-advanced/hocs';
import { NavigationElement } from 'modules/shared/models';

import { WithCatalogueSEO } from '../../hocs';
import { getParentNavigation } from '../../utils';
import { productService } from '../../services';
import { Product, GetProduct } from '../../models';

import { ProductProps } from './product-type';
import { QUERY } from './product-query';
import { ProductLoader } from './product-loader';

const getBrand = (props?: ProductProps): { typeName: string; value: string } | undefined => {
    if (props && props.product && props.product.brand && props.product.brand.name) {
        return { typeName: 'marque', value: props.product.brand.name };
    }

    return undefined;
};

const getRessourceName = (props?: ProductProps): string | undefined => {
    if (props && props.product) {
        return props.product.name;
    }

    return undefined;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getParams = (props?: any): { key: string; value: string }[] => {
    if (!props || !props.product) {
        return [];
    }

    const {
        product: { brand },
    } = props;
    const brandId = `${brand ? (brand.id || '').trim() : ''}`;
    const parentBrandId = `${brand ? (brand.parentBrandId || '').trim() : ''}`;
    return [
        { key: 'signId', value: `${brand ? brand.signId : '-1'}` },
        { key: 'brandId', value: brandId !== '' ? brandId : '-1' },
        { key: 'parentBrandId', value: parentBrandId !== '' ? parentBrandId : '-1' },
    ];
};

const getAdditionalParentTree = (
    props?: ProductProps,
    parentNavigationTree?: NavigationElement,
): NavigationElement | undefined => {
    if (props && props.product) {
        return getParentNavigation(props.product, parentNavigationTree);
    }

    return undefined;
};

const enhancer = compose<React.ComponentType<GetProduct & WithNotifyRessourceLoadedInputProps>>(
    WithStatelessDatasFetchingByParameters<Product, ProductProps, GetProduct>(
        productService.get,
        ProductLoader,
        'redirect',
        'product',
        ['id', 'offline'],
        undefined,
        true,
    ),
    WithFetchDatasByParamsFromCMS<ProductProps>(
        ProductLoader,
        QUERY,
        undefined,
        [
            { name: 'signAdvantageFilter', filter: "data/signId/iv eq '$signId'" },
            {
                name: 'brandAdvantageFilter',
                filter: 'data/brandId/iv eq $brandId or data/brandId/iv eq $parentBrandId',
            },
            { name: 'cornerFilter', filter: "data/brandId/iv eq $brandId and data/typeMarque/iv eq 'catalogue'" },
        ],
        undefined,
        true,
        getParams,
    ),
    WithNotifyRessourceLoaded(getRessourceName, getAdditionalParentTree, getBrand),
    WithCatalogueSEO<ProductProps>('product'),
);
export default enhancer;
